import { css } from "lit-element"

export const GlobalCSS = css`
        a {
            color: rgb(152, 34, 72);
        }
`